import { render, staticRenderFns } from "./NgVideoYoutube.vue?vue&type=template&id=2d8d9114"
import script from "./NgVideoYoutube.vue?vue&type=script&lang=js"
export * from "./NgVideoYoutube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports